module.exports = __webpack_public_path__ + "img/close.0424aae9.svg";